export const GoldTrophy = ({ className = "h-6 w-6", ...rest }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden {...rest}>
    <defs>
      <linearGradient id="en-gold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#FFD766" />
        <stop offset="0.5" stopColor="#FFC20E" />
        <stop offset="1" stopColor="#D4AF37" />
      </linearGradient>
    </defs>
    <path fill="url(#en-gold)" d="M7 3h10v2h3a1 1 0 0 1 1 1v1.5c0 2.7-1.9 4.9-4.4 5.4A5 5 0 0 1 13 15.9V18h3a1 1 0 0 1 1 1v2H7v-2a1 1 0 0 1 1-1h3v-2.1a5 5 0 0 1-3.6-3A5.7 5.7 0 0 1 3 7.5V6a1 1 0 0 1 1-1h3V3zm10 4v3.3c1.3-.5 2-1.6 2-2.8V7h-2zM7 7H5v.5c0 1.2.7 2.3 2 2.8V7z" />
    <path fill="#B8902C" opacity="0.5" d="M11 18h2v-2.1a5 5 0 0 1-1 .1 5 5 0 0 1-1-.1V18z" />
  </svg>
);
